<template>
  <div class="col-12">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-10 col-lg-6">
        <div class=" row text-center ml-5">
          <div class="mb-5">
            <img src="../../assets/tn_cybertech_grad_logo.png" class="tn-logo" style="width: 200px; height: auto;">
          </div>
          <h2 class="ui inverted purple text">HEPII day, <strong>Welcome!</strong></h2>
          <p v-if="step === 'initial'" class="text-muted mt-4">Let's get started! Please submit your phone number or email address to proceed.</p>
          <p v-else-if="step === 'needPhone'" class="text-muted mt-4">Please provide your phone number for OTP verification.</p>
          <p v-else-if="step === 'phoneExists'" class="text-muted mt-4">Please choose an option below.</p>
          <p v-else-if="step === 'login'" class="text-muted mt-4">Welcome back! Please enter your PIN to continue.</p>
        </div>
        <div class="ui fitted divider mt-2"></div>
        <form v-bind:class="{ 'ui form double loading': isBusy() }" @submit.prevent="submitForm()">

          <div class="ui large form mt-5">
            <!-- Step 1: Email or Phone -->
            <div class="field floating">
              <label class="text-muted">{{ step === 'needPhone' ? 'Email' : 'Phone Or Email' }}</label>
              <input class="primary" type="text" :disabled="step !== 'initial' || isPhoneParamProvided"
                v-model="auth.username" placeholder="">
              <small v-if="step === 'initial' && !isEmail" class="text-muted mt-1">
                Please include country code e.g 263
              </small>
            </div>

            <!-- Step 2a: Phone field (when email entered and needs to register) -->
            <div v-if="step === 'needPhone'" class="field floating">
              <label class="text-muted">Phone Number</label>
              <input class="primary" type="text" v-model="auth.phone" placeholder="">
              <small class="text-muted mt-1">
                Phone number is required for OTP verification (e.g 263771234567)
              </small>
            </div>

            <!-- Step 2b: Phone exists - show warning and options -->
            <div v-if="step === 'phoneExists'">
              <div class="ui orange floating message m-4">
                <div class="header">
                  <i class="exclamation triangle icon"></i>
                  Phone Number Already Registered
                </div>
                <p class="mt-2">The phone number <strong>{{ auth.phone }}</strong> is already associated with an existing account.</p>
                <p>You can either login with this phone number or use a different one for registration.</p>
              </div>
            </div>

            <!-- Step 2c: Password field (when user exists and needs to login) -->
            <div v-if="step === 'login'" class="field">
              <label>Pin</label>
              <input type="password" v-model="auth.password" placeholder="Pin">
            </div>

            <!-- Buttons for phoneExists step -->
            <template v-if="step === 'phoneExists'">
              <button type="button" class="ui button large purple fluid mt-4" @click="loginWithPhone()">
                Login with this phone
                <i class="sign in icon"></i>
              </button>
              <button type="button" class="ui button large basic purple fluid mt-4" @click="useDifferentPhone()">
                Use a different phone
                <i class="redo icon"></i>
              </button>
            </template>

            <!-- Default submit button -->
            <button v-if="step !== 'phoneExists'" class="large ui button large purple fluid mt-4" :disabled="!isFormValid" type="submit">
              {{ buttonText }}
              <i class="arrow right icon"></i>
            </button>

            <!-- Back button when not on initial step -->
            <button v-if="step !== 'initial' && step !== 'phoneExists'" type="button" class="ui button large basic grey fluid mt-4" @click="goBack()">
              Back
            </button>
<!--
            <div class="ui fitted divider mt-2"></div>
-->
            <!-- <div class="d-flex align-items-end mt-3">
                <p class="fw-light"> A step-by-step guide on how to open an account as a
                  <a @click="openPdf('NewCustomer.pdf')" class="ui purple tertiary button align-self-end">New Customer</a>
                  or
                  <a @click="openPdf('ExistingCustomer.pdf')" class="ui purple tertiary button align-self-end">Existing Customer</a>
                </p>
              </div> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { utils } from "@/utils/utils";
import { Notify } from "../../utils/notifications";
import { useAuthStore } from '@/stores/auth';

export default {
  name: "Main",
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  data() {
    return {
      step: 'initial', // 'initial' | 'needPhone' | 'phoneExists' | 'login'
      auth: {
        username: "",
        password: "",
        channel: "WEB",
        phone: "",
      },
      errors: {},
      operations: 0,
    };
  },
  mounted() {
    this.getPhoneNumberFromUrlParams();
  },
  computed: {
    isPhoneParamProvided() {
      const { channel, phone } = this.$route.params;
      return !!channel && !!phone;
    },
    isEmail() {
      return !!this.auth.username && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.auth.username);
    },
    isPhoneNumber() {
      return !!this.auth.username && /^[0-9]{7,15}$/.test(this.auth.username);
    },
    isPhoneFieldValid() {
      return !!this.auth.phone && /^[0-9]{7,15}$/.test(this.auth.phone);
    },
    isFormValid() {
      if (this.step === 'initial') {
        // Just need valid email or phone
        return this.isEmail || this.isPhoneNumber;
      } else if (this.step === 'needPhone') {
        // Need valid phone for OTP
        return this.isPhoneFieldValid;
      } else if (this.step === 'login') {
        // Need password
        return !!this.auth.password && this.auth.password.length >= 4;
      }
      return false;
    },
    buttonText() {
      if (this.step === 'initial') return 'Next';
      if (this.step === 'needPhone') return 'Continue';
      if (this.step === 'login') return 'Login';
      return 'Next';
    },
  },
  methods: {
    submitForm() {
      if (this.step === 'initial') {
        this.checkUserExists();
      } else if (this.step === 'needPhone') {
        this.proceedToVerify();
      } else if (this.step === 'login') {
        this.doLogin();
      }
    },

    checkUserExists() {
      const payload = {
        username: this.auth.username,
        channel: this.auth.channel,
      };

      this.post_auth_no_auth('/authentication', { ...payload, requestType: 'CHECK_USER' }, "Checking...")
        .then(res => {
          if (!res || !res.body) {
            Notify.fire("Error", "Unable to verify user. Please try again.", "error");
            return;
          }

          const status = res.body.status;
          this.setCustomerStatus(status);

          if (status === 'LOGIN') {
            // User exists - show password field
            this.step = 'login';
          } else if (status === 'REGISTER') {
            // New user - check if they entered email or phone
            if (this.isEmail) {
              // Email entered - need phone for OTP
              this.step = 'needPhone';
            } else {
              // Phone entered - go directly to verify
              this.setPhone(this.auth.username);
              this.setEmail(null);
              this.setIsPhoneParamProvided(this.isPhoneParamProvided);
              this.$router.push('/omni/verify');
            }
          } else if (res.body.message) {
            Notify.fire("Info", res.body.message, "info");
          }
        })
        .catch(e => {
          utils.logger(e);
          Notify.fire("Error", "Unable to verify user. Please try again.", "error");
        });
    },

    proceedToVerify() {
      // First check if the phone number already exists
      const payload = {
        username: this.auth.phone,
        channel: this.auth.channel,
      };

      this.post_auth_no_auth('/authentication', { ...payload, requestType: 'CHECK_USER' }, "Checking phone...")
        .then(res => {
          if (!res || !res.body) {
            Notify.fire("Error", "Unable to verify phone number. Please try again.", "error");
            return;
          }

          const status = res.body.status;

          if (status === 'LOGIN') {
            // Phone already exists - show options
            this.step = 'phoneExists';
          } else if (status === 'REGISTER') {
            // Phone is available - proceed to verify
            this.setEmail(this.auth.username);
            this.setPhone(this.auth.phone);
            this.setIsPhoneParamProvided(this.isPhoneParamProvided);
            this.$router.push('/omni/verify');
          }
        })
        .catch(e => {
          utils.logger(e);
          Notify.fire("Error", "Unable to verify phone number. Please try again.", "error");
        });
    },

    doLogin() {
      const payload = {
        username: this.auth.username,
        password: this.auth.password,
        channel: this.auth.channel
      };

      this.post_auth_no_auth('/authentication', { ...payload, requestType: 'AUTHENTICATION' }, "Logging in...")
        .then(res => {
          if (res && res.success && res.body.accessToken) {
            this.login({
              accessToken: res.body.accessToken,
              user: {
                id: res.body.userId,
                name: res.body.name,
                full_name: `${res.body.name} ${res.body.lastName}`,
                email: res.body.email,
                idNo: res.body.idNo,
                idNoType: res.body.idNoType,
              },
            });
            this.setPhone(res.body.phone);
            this.setEmail(res.body.email);
            Notify.fire("Success", `Welcome back!`, "success");
            this.$router.push("/omni/home");
          } else {
            Notify.fire("Error", res?.message || "Authentication failed. Please try again.", "error");
          }
        })
        .catch(e => {
          utils.logger(e);
          Notify.fire("Error", "Authentication failed. Please try again.", "error");
        });
    },

    goBack() {
      this.step = 'initial';
      this.auth.password = '';
      this.auth.phone = '';
    },

    loginWithPhone() {
      // Switch to login with the phone number
      this.auth.username = this.auth.phone;
      this.auth.phone = '';
      this.step = 'login';
    },

    useDifferentPhone() {
      // Go back to needPhone step to enter a different phone
      this.auth.phone = '';
      this.step = 'needPhone';
    },

    getPhoneNumberFromUrlParams() {
      const { channel, phone } = this.$route.params;
      if (channel && phone) {
        this.auth.channel = channel;
        this.auth.username = phone;
      }
    },
    login(data) { this.authStore.login(data); },
    setCustomerStatus(status) { this.authStore.setCustomerStatus(status); },
    setPhone(phone) { this.authStore.setPhone(phone); },
    setEmail(email) { this.authStore.setEmail(email); },
    setIsPhoneParamProvided(value) { this.authStore.setIsPhoneParamProvided(value); },
    ...baseMethods,
  },
};
</script>